<template>
  <div class="jimun-container">
    <div class="jimun-row">
      <div class="sentense">
        <div class="point wordpiece wordblock" id="w1000">
          Hello,
          <div class="commentpiece">(S)</div>
        </div>
        <div class="point wordpiece wordblock" id="w1001">
          I was wondering
          <div class="commentpiece">(P.V)</div>
        </div>
      </div>
      <div class="comment">이 라인은 해석을 위한 라인</div>
    </div>

    <div class="jimun-row">
      <div class="sentense">
        <div class="underline1 wordpiece wordblock" id="w1010">
          <div class="underline2 wordpiece wordblock" id="w1002">
            Hello,
            <div class="commentpiece point1Color">(S)</div>
          </div>
          <div class="underline2 wordpiece wordblock" id="w1003">
            I was wondering
            <div class="commentpiece point1Color">(P.V)</div>
          </div>
          <div class="commentpiece point2Color">(Prsv)</div>
        </div>

        <div class="wordpiece wordblock" id="w1006">after</div>
        <div class="wordpiece wordblock" id="w1005">all</div>
        <div class="underline2 wordpiece wordblock" id="w1005">
          these years
          <div class="commentpiece point1Color">(NMT:TIME)</div>
        </div>
        <div class="wordpiece wordblock paint" id="w1005">you'd like to meet</div>
      </div>
      <div class="comment">블럭은 다른 블럭을 포함할수 있다</div>
    </div>
  </div>
</template>

<script>
export default {};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
div.jimun-container {
  padding: 5px;
  font-family: $font;
  .wordpiece {
    position: relative;
    display: inline-block;
  }
  // .wordblock:nth-child(even) {
  //   text-decoration: underline;
  //   text-decoration-color: orange;
  // }
  // .wordblock:nth-child(odd) {
  //   text-decoration: underline;
  //   text-decoration-color: crimson;
  // }

  .wordblock:first-child {
    margin-left: 0px;
  }
  // .wordblock:last-child {
  //   margin-left: 0px;
  // }
  .wordblock {
    margin-left: 4px;
  }

  .commentpiece {
    position: absolute;
    font-size: 0.7em;
    // color: $point1;
    font-weight: 400;
    width: 100%;
    text-align: center;
  }
  .point1Color {
    color: $point1;
  }
  .point2Color {
    color: $point2;
  }
  div.paint {
    background-color: $point1;
    border-radius: 3px;
    color: $gray50;
  }

  div.underline1 {
    padding-bottom: 2px;
    border-bottom: 0.5px solid coral;
  }
  div.underline2 {
    border-bottom: 0.5px solid crimson;
  }

  span.point {
    background-color: $gray200;
    border-radius: 10%;
  }

  div.comment {
    margin-top: $line-height;
    font-size: 0.9em;
    color: $gray500;
  }
  div.comment::before {
    content: "";
    display: block;
    clear: both;
  }
  div.jimun-row {
    margin-bottom: 0.5em;
  }
}
</style>